var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIconCancellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#6921C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97654 8.91445C5.61712 8.49512 4.98582 8.44656 4.56649 8.80598C4.14717 9.1654 4.09861 9.7967 4.45803 10.216L5.97654 8.91445ZM7.82598 12.6087L7.06672 13.2595C7.23994 13.4616 7.48657 13.5863 7.75201 13.606C8.01744 13.6257 8.27977 13.5387 8.48091 13.3644L7.82598 12.6087ZM15.0027 7.71223C15.42 7.35052 15.4651 6.71897 15.1034 6.30161C14.7417 5.88426 14.1101 5.83915 13.6928 6.20085L15.0027 7.71223ZM4.45803 10.216L7.06672 13.2595L8.58524 11.9579L5.97654 8.91445L4.45803 10.216ZM8.48091 13.3644L15.0027 7.71223L13.6928 6.20085L7.17105 11.853L8.48091 13.3644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconCancellation);
export default __webpack_public_path__ + "static/media/checkedIconCancellation.bd84a3e9.svg";
export { ForwardRef as ReactComponent };